import { render, staticRenderFns } from "./AirtimePrice.vue?vue&type=template&id=463868c2&scoped=true&"
import script from "./AirtimePrice.vue?vue&type=script&lang=js&"
export * from "./AirtimePrice.vue?vue&type=script&lang=js&"
import style0 from "./AirtimePrice.vue?vue&type=style&index=0&id=463868c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463868c2",
  null
  
)

export default component.exports